import { Component, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { PetFnolComponent } from "../../modules/pet/pet-fnol/pet-fnol.component";
import { Observable } from "rxjs";

@Component({
  selector: 'cpf-pet-fnol-page',
  templateUrl: './pet-fnol-page.component.html',
  styleUrls: ['./pet-fnol-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class PetFnolPageComponent {
  @ViewChild(PetFnolComponent) petFnolComponent?: PetFnolComponent;

  canDeactivate(): Observable<boolean> | boolean {
    return this.petFnolComponent?.canDeactivate() ?? true;
  }
}
